import { render, staticRenderFns } from "./header3.vue?vue&type=template&id=267e5f10&scoped=true"
import script from "./header3.vue?vue&type=script&lang=js"
export * from "./header3.vue?vue&type=script&lang=js"
import style0 from "./header3.vue?vue&type=style&index=0&id=267e5f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e5f10",
  null
  
)

export default component.exports